import { render, staticRenderFns } from "./Delivery-Team-Detail.vue?vue&type=template&id=4ce3f696"
import script from "./Delivery-Team-Detail.vue?vue&type=script&lang=js"
export * from "./Delivery-Team-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports